/*  ==========================================================================
		PHP Variables
		========================================================================== */

// If you need to access variables such as template url, or AJAX url within this file you can use the variable php_variables.template_url or php_variables.ajax_url
// which has been passed in via enqueue-scripts.php

/*  ==========================================================================
		Grid variables - needed for gridcarousel__init
		========================================================================== */

// NOTE: If your updating this make sure to also update the SASS Variables in _variables.scss
const gridSizes = {
  sm: "550",
  md: "700",
  lg: "1000",
  xl: "1200",
  ws: "1400",
  xw: "1600",
  xxw: "1800",
  xxxw: "2000"
};

/*  ==========================================================================
      DOM element variables 
      ========================================================================== */

const body = document.querySelector("body");

/*  ==========================================================================
		Device Detection - Check if is mobile or ipad
		========================================================================== */

let isMobile = false; // initiate as false
const isTouchDevice = !!("ontouchstart" in window);

if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) {
  isMobile = true;
}

/*  ==========================================================================
		Create a 100vh css variable
		========================================================================== */

const setViewHeight = function () {
  // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
  let vh = window.innerHeight;
  // Then we set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty("--vh", `${vh}px`);
};

setViewHeight();

window.addEventListener("resize", () => {
  setViewHeight();
});

/*  ==========================================================================
		GENERAL - add linklines to links
		========================================================================== */

const linksInit = function () {
  const links = document.querySelectorAll("a:not(.noline):not(.line-added), button.btn:not(.noline):not(.line-added)");
  links.forEach(function (el) {
    if (el.closest(".noline")) {
      return;
    }

    const icon = el.querySelector(".fa, .fa-solid, .fa-regular, .fa-light, .fa-thin, .fa-brands");

    if (el.querySelector("img") < 1) {
      const linkHTML = "<span class='linkline'>" + el.textContent + "</span>";
      el.innerHTML = linkHTML;
      el.classList.add("line-added");
      if (icon) {
        const iconHTML = icon;
        if (icon.classList.contains("fa--left")) {
          el.querySelector(".linkline").before(icon);
        } else {
          el.querySelector(".linkline").after(icon);
        }
      }
    }
  });
  //return true;
}; // linksInit();
linksInit();

/*  ==========================================================================
    GENERAL - accordion
    ========================================================================== */

const accordionQuestions = document.querySelectorAll(".accordion__question");

const accordionInit = function (accordionItems) {
  if (!accordionItems) {
    return;
  }

  accordionItems.forEach(item => {

    let isTestimonial = false;
    // if it's part of a testimonials accordion
    if(item.closest(".accordion--testimonials")){
      isTestimonial = true;
    }

    item.addEventListener("click", function () {
      if(isTestimonial){
        let accordionParentEl = item.closest(".accordion--testimonials");
        if(accordionParentEl.querySelector('.accordion__item--open')){
          accordionParentEl.querySelector('.accordion__item--open .accordion__question').click();
        }
      }

      item.closest(".accordion__item").classList.toggle("accordion__item--open");
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  });

  window.addEventListener("resize", function () {
    accordionItems.forEach(function (item) {
      if (item.closest(".accordion__item").classList.contains("accordion__item--open")) {
        let panel = item.nextElementSibling;
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  });
}; // accordionInit();
accordionInit(accordionQuestions);

/*  ==========================================================================
    GENERAL - Testimonials
    ========================================================================== */
const testimonialModules = document.querySelectorAll(".accordion--testimonials");

const testimonialsInit = function () {
  if (!testimonialModules || testimonialModules.length <= 0) {
    return;
  }

  testimonialModules.forEach(item => {
    let accitems = item.querySelectorAll('.accordion__question');
    // Opening the first item
    accitems[0].click();
  });

}; //testimonialsInit 
testimonialsInit();

/*  ==========================================================================
	GENERAL - Listed Content Tabs
	========================================================================== */

  const listedContent = document.querySelectorAll(".module--listed-content");
    
  const listedContentInit = function () {
  
    if (listedContent.length <= 0) {
      return;
    }
  
    listedContent.forEach(module => {
  
      const options = module.querySelectorAll('.listed-content__nav .listed-content__option');
      const listeditems = module.querySelector('.listed-content__items');
      const dot = module.querySelector('.listed-content__nav .dot');
      const nav = module.querySelector('.listed-content__nav');
  
      options.forEach(option => {
        //  Initialising the position of the dot and the height of the active option
        if(option.classList.contains('active')){
          dot.style.top = option.offsetTop + option.offsetHeight/2 - dot.offsetHeight/2 + 'px';
          let activeMediaItem = module.querySelector('.item--media.active');
          let activeTextItem = module.querySelector('.item--textcontent.active');
          let activeTextItemHeight = activeTextItem.querySelector('.item__textcontent') ? activeTextItem.querySelector('.item__textcontent').scrollHeight : 0;

          // activeMediaItem.style.height = activeTextItemHeight + nav.scrollHeight + 200 + "px";
          activeTextItem.style.height = activeTextItemHeight + nav.scrollHeight + "px";
        }
        option.addEventListener('mouseenter', () => {
          dot.style.top = option.offsetTop + option.offsetHeight/2 - dot.offsetHeight/2 + 'px'; 
        });
        option.addEventListener('mouseleave', () => {
          let activeitem = module.querySelector('.listed-content__nav .listed-content__option.active');
          dot.style.top = activeitem.offsetTop + activeitem.offsetHeight/2 - dot.offsetHeight/2 + 'px';
        });

        option.addEventListener("click", function () {
          let activeIndex = option.dataset.id;

          let currentActiveOption = module.querySelector('.listed-content__nav .listed-content__option.active');
          currentActiveOption.classList.remove('active');

          option.classList.add('active');
          dot.style.top = option.offsetTop + option.offsetHeight/2 - dot.offsetHeight/2 + 'px';

          // removing active from the current active item unless it has the same index
          let currentMediaItem = module.querySelector('.item--media.active');
          let currentTextItem = module.querySelector('.item--textcontent.active');
          if(currentTextItem && currentTextItem.dataset.id !== activeIndex){
            // currentMediaItem.style.height = null;
            currentMediaItem.classList.remove('active');
            currentTextItem.style.height = null;
            currentTextItem.classList.remove('active');
          }

          let nextactiveMediaItem = module.querySelector('.item--media[data-id="item-'+activeIndex+'"]');
          let nextactiveTextItem = module.querySelector('.item--textcontent[data-id="item-'+activeIndex+'"]');

          if(nextactiveTextItem){
            nextactiveMediaItem.classList.add('active');
            let nexxtactiveTextItemHeight = nextactiveTextItem.querySelector('.item__textcontent') ? nextactiveTextItem.querySelector('.item__textcontent').scrollHeight : 0;

            nextactiveTextItem.style.height = nexxtactiveTextItemHeight + nav.scrollHeight  + "px";
            nextactiveTextItem.classList.add('active');
          }

            // opening the next active item
            // let nextactiveitems = module.querySelectorAll('.item[data-id="item-'+activeIndex+'"]');
            // if(nextactiveitems){
            //   nextactiveitems.forEach(nextitem => {
            //     nextitem.classList.add('active');
            //     let nexxtactiveTextItemHeight = nextitem.querySelector('.item__textcontent') ? nextitem.querySelector('.item__textcontent').scrollHeight : 0;
            //     nextitem.style.height = nexxtactiveTextItemHeight + nav.scrollHeight + 150 + "px";
            //   });
              
            // }
          
        });

      });

      window.addEventListener("resize", function () {
        let activeitemoption = module.querySelector('.listed-content__nav .listed-content__option.active');
        dot.style.top = activeitemoption.offsetTop + activeitemoption.offsetHeight/2 - dot.offsetHeight/2 + 'px';
  
        let activeTextItem = module.querySelector('.item--textcontent.active');
        let activeTextItemHeight = activeTextItem.querySelector('.item__textcontent') ? activeTextItem.querySelector('.item__textcontent').scrollHeight : 0;

        activeTextItem.style.height = activeTextItemHeight + nav.scrollHeight + "px";
      });

    });
  
  }; // listedContentInit()
  listedContentInit();

/*  ==========================================================================
	GENERAL - Tech Specs
	========================================================================== */

  const techSpecModules = document.querySelectorAll(".module--tech-spec");
    
  const techSpecInit = function () {
  
    if (techSpecModules.length <= 0) {
      return;
    }

    techSpecModules.forEach(module => {
      const options = module.querySelectorAll('.tech-spec__option');

      options.forEach(option => {
        option.addEventListener('click', function(){
          let active = this.dataset.option;
          module.dataset.active = active;
        });
      });
    });

    
  };
  techSpecInit();

/*  ==========================================================================
    GENERAL - LazyLoad - Enable Lazy load for images
    ========================================================================== */

// Lazy load images (or everything with .lazy)
const lazyLoadInstance = new LazyLoad();

/*  ==========================================================================
    GENERAL - Initiate plyr (custom video controls)

    This is automatically disabled on builds, to enable uncomment the JS here
    and then go to functions / enqueue-scripts and enqueue-styles to uncomment and enable the css and JS 

    ========================================================================== */

const plyrsInit = function () {
  const plyrs = document.querySelectorAll(".mediavideo");
  if (!plyrs) {
    return;
  }

  plyrs.forEach(function (el) {
    let plyr = el.querySelector(".mediavideo__video");
    const player = new Plyr(plyr, {
      controls: ["play", "progress", "mute", "current-time", 'fullscreen', 'volume'],
      hideControls: true,
      captions: { active: true, language: 'auto', update: false },
      invertTime: false,
      tooltips: { controls: false, seek: false }
    });   // pause after 5 seconds

    setTimeout(() => {
      if(player){
        player.muted = true;
        player.toggleCaptions(true); // force captions ON
        player.toggleCaptions(false); // force captions ON
      }
    }, 1000);

    // Listen for pause event
    player.on("pause", () => {
      const parent = el.closest(".video__media");
      if (parent) {
        parent.classList.add("paused");
      }
    });

    // Optional: remove the class when video plays again
    player.on("play", () => {
      const parent = el.closest(".video__media");
      if (parent) {
        parent.classList.remove("paused");
      }
    });
  });
}; // plyrsInit();

 plyrsInit();


/*  ==========================================================================
  GENERAL - Share Icons
========================================================================== */
const socialLinksInit = function () {
  const socialLinks = document.querySelectorAll(".sociallink--popup");

  if (!socialLinks || socialLinks.length <= 0) {
    return;
  }

  socialLinks.forEach(socialLink =>
    socialLink.addEventListener("click", function (e) {
      e.preventDefault();
      const shareURL = this.getAttribute("href");
      var w = 550;
      var h = 550;
      var left = Number(screen.width / 2 - w / 2);
      var tops = Number(screen.height / 2 - h / 2);
      window.open(
        shareURL,
        "share-dialog",
        "resizable=no, width=" + w + ", height=" + h + ", top=" + tops + ", left=" + left + ""
      );
    })
  );
}; // socialLinksInit();
socialLinksInit();

/*  ==========================================================================
    GENERAL - Fancybox
  ========================================================================== */
const fancyboxInit = function () {

  Fancybox.bind("[data-fancybox]", {
    Hash: false, // Disabling Hash-based navigation, as it doesn't work on page reload
    Thumbs: false, // Disable thumbnails
    trapFocus: false,
    defaultType: "inline",
    dragToClose: false,
    animated: true,
    showClass: "fancybox-fadeInRight",
    hideClass: "fancybox-fadeOutRight",
    on: {
      reveal: (fancybox, slide) => {
        
        const src = slide.src || '';
        const container = fancybox.container; 
        
        if (src.includes('youtube.com') || src.includes('youtu.be') || src.includes('youtube-nocookie')) {
          container.classList.add('isvideopopup');
        } else if (src.includes('vimeo.com')) {
          container.classList.add('isvideopopup');
        }else{
          container.classList.add('sidepopup');
        }
      },
    }
  });

  document.addEventListener("click", function (e) {
  const container = document.querySelector(".fancybox__container");

  if (container && container.contains(e.target)) {
    const content = container.querySelector(".fancybox__content");

    // If clicked inside container but NOT inside content
    if (!content.contains(e.target)) {
      Fancybox.close();
    }
  }
});


}; // fancyboxInit();

document.addEventListener("DOMContentLoaded", fancyboxInit);

document.addEventListener('DOMContentLoaded', () => {
  const offset = document.querySelector('.siteheader').offsetHeight; // adjust selector or fallback

  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const targetId = this.getAttribute('href').slice(1);
      const targetEl = document.getElementById(targetId);
      
      if (targetEl) {
        e.preventDefault();

        const targetPosition = targetEl.getBoundingClientRect().top + window.pageYOffset;
        const scrollTo = targetPosition - offset;

        window.scrollTo({
          top: scrollTo,
          behavior: 'smooth'
        });
      }
    });
  });
});

/*  ==========================================================================
    AJAX - AJAX load more / paging
    ========================================================================== */

const loadmoreBtn = document.querySelector(".paging__loadmore");
const loadmoreContainer = document.querySelector(".loadmore-container");

const loadmoreLoadPostsMultiplePages = function (pages) {
  if (pages && pages > 1) {
    //Stopping default scroll back to previous position
    history.scrollRestoration = "manual";

    const currentPage = new URL(window.location);

    //Creating an array on page numbers to map it
    var list = [];
    for (var i = 1; i < pages; i++) {
      list.push(i);
    }

    // Initialising the array of posts pages
    var postsHTML = [];

    const button = loadmoreBtn;
    const buttonText = button.innerHTML; // store current button text
    button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts

    // Array of ajax calls
    var allAJAX = list.map(function (page) {
      const data = {
        action: "loadmore",
        query: php_variables.posts, // that's how we get params from wp_localize_script() function
        page: page
      };
      //Updating the url to mtch the page number
      currentPage.searchParams.set("pagenum", page);
      return $.ajax({
        url: php_variables.ajax_url, // AJAX handler
        data: data,
        type: "POST",
        success: function (data) {
          postsHTML[page] = data;
        }
      });
    });

    // Waiting for all the ajax calls to be finished before proceeding
    Promise.all(allAJAX).then(function () {
      // Update current page variable
      php_variables.current_page = pages;

      button.innerHTML = buttonText; // set back to previous button text

      // Adding the new tiles to the dom
      list.map(page => {
        if (postsHTML[page]) {
          loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + postsHTML[page];
        }
      });

      // Updating the href for the loadmore button
      const nextPage = new URL(window.location);
      nextPage.searchParams.set("pagenum", parseInt(pages) + 1);
      button.href = nextPage;

      // if last page, remove the button..
      if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
        button.style.display = "none";
      }

      // Re-init lazy load
      lazyLoadInstance.update(); // reinit lazy load after clones
      // Re-init effects
      const effects = document.querySelectorAll(".effect");
      effectsInit(effects);

      // Scrolling the page to the last known position
      if (localStorage.getItem("scrollPosition")) {
        window.scroll({
          top: parseInt(localStorage.getItem("scrollPosition"), 10),
          behavior: "instant"
        });
      }
    });
  }
};

const loadmoreLoadPosts = function (e) {
  e.preventDefault(); // Preventing the a tag from redirecting to the page
  const button = this;
  const data = {
    action: "loadmore",
    query: php_variables.posts, // that's how we get params from wp_localize_script() function
    page: php_variables.current_page
  };
  let buttonText; // create variable to store button text

  // This AJAX triggers a PHP hook within functions-ajax.php called ajax_loadmore_handler
  $.ajax({
    url: php_variables.ajax_url, // AJAX handler
    data: data,
    type: "POST",
    beforeSend: function (xhr) {
      buttonText = button.textContent; // store current button text
      button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts
    },
    success: function (data) {
      if (data) {
        button.textContent = buttonText; // set back to previous button text
        loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + data; // insert new posts to the loadmore-container, this should be the row that includes the posts

        php_variables.current_page++;

        // Only push state to set the last page number or if there is more pages to load
        const currentPage = new URL(window.location);

        if (parseInt(php_variables.current_page) <= parseInt(php_variables.max_page)) {
          currentPage.searchParams.set("pagenum", php_variables.current_page);
          history.pushState({}, "", currentPage);
        }

        //Updating the loadmore link
        const nextPage = new URL(window.location);
        nextPage.searchParams.set("pagenum", parseInt(php_variables.current_page) + 1);

        button.href = nextPage;

        // if last page, remove the button..
        if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
          button.style.display = "none";
        }
        // Re-init links to make sure linklines on newly loaded content still work
        linksInit();
        // Re-init lazy load
        lazyLoadInstance.update(); // reinit lazy load after clones
        // Re-init effects
        const effects = document.querySelectorAll(".effect");
        effectsInit(effects);
      } else {
        button.style.display = "none"; // if no data, remove the button as well
      }
    }
  });
}; // loadmoreLoadPosts();

const loadmoreInit = function () {
  if (!loadmoreBtn) {
    return;
  }
  /** When adding fitering you will need to move this part into the filtering call */
  // Checking if the page paramenter is set
  const currentPage = new URL(window.location);
  let currentPageNum = currentPage.searchParams.get("pagenum");

  //If there is more than one page to load
  if (currentPageNum && currentPageNum > 1) {
    currentPageNum = currentPageNum > php_variables.max_page ? php_variables.max_page : currentPageNum;
    loadmoreLoadPostsMultiplePages(currentPageNum);
  }
  /** -end- */

  // Saving the scroll position before unload
  window.addEventListener("unload", function (e) {
    var scrollPosition = window.pageYOffset;
    localStorage.setItem("scrollPosition", scrollPosition);
  });

  loadmoreBtn.addEventListener("click", loadmoreLoadPosts);
}; // loadmoreInit();

loadmoreInit();

/*  ==========================================================================
    AJAX - Filtering 
    ========================================================================== */

    /*  ==========================================================================
   filterUpdateURL: Updates the url with the selected values
    ========================================================================== */

const filterUpdateURL = function (filterData, searchData) {
  let url_params = "";

  const keys = Object.keys(filterData);

  if (filterData) {
    keys.forEach(key => {
      if(filterData[key] !== ''){
        url_params = "?filter_" + key + "=" + filterData[key];
      }
    });
  }

  if(searchData){
    if (url_params === "") {
      url_params = url_params + "?";
    } else {
      url_params = url_params + "&";
    }
    url_params = url_params + "search=" + searchData;
  }

  // Pagination paramters
  const currentPage = new URL(window.location);
  let currentPageNum = currentPage.searchParams.get("pagenum");

  if (currentPageNum && url_params === "") {
    if (url_params === "") {
      url_params = url_params + "?";
      url_params = url_params + "pagenum=" + currentPageNum;
    }
  }

  let currentPageUrl = window.location.href.split("?")[0];
  let newUrl = currentPageUrl + url_params;

  window.history.pushState({ path: newUrl }, "", newUrl);


  currentPageUrl = newUrl;
};

const filterGetData = function () {

  let filter_data = {};

  filter_settings.filters.forEach(function (el) {
    let checkedOption = document.querySelector('.filter__option input[type="checkbox"][name=' + el.name + "]:checked");
    if(checkedOption && checkedOption.value !==''){
      filter_data[el.name] = checkedOption.value;
    }
  });
  
  return filter_data;
};

const filterGetPosts = function () {

  let filterData = filterGetData();

  let filterSearchInput = document.querySelector(".filter__option input[type='search']");
  let searchData = filterSearchInput ? filterSearchInput.value : '';

  if ((!filterData || Object.keys(filterData).length === 0) && searchData === '') {
    return;
  }

  filterUpdateURL(filterData, searchData);

  // Currently turned off
  // // Scroll to filtering system
  // if (document.querySelector(".filter-pin")) {
  //   document.querySelector(".filter-pin").scrollIntoView({ behavior: "smooth"});
  // }

  // Start filtering
  document.querySelector(".loadmore-container").classList.add("filtering");

  // Trigger ajax
  let data = {
    action: "filter",
    query: php_variables.posts, // that's how we get params from wp_localize_script() function in enqueue-scripts.php
    filter_settings: filter_settings, // passed in via wp_localize_script in filters.php
    filter_data: filterData,
    search_data: searchData
  };

  $.ajax({
    url: php_variables.ajax_url,
    data: data, // form data
    dataType: "json", // this data type allows us to receive objects from the server
    type: "POST",
    success: function (data) {

      // when filter applied:
      // set the current page to 1
      php_variables.current_page = 1;

      // set the new query parameters
      php_variables.posts = data.posts;

      // set the new max page parameter
      php_variables.max_page = data.max_page;

      // hide load more button, if there are not enough posts for the second page

      const pagingLoadmore = document.querySelector(".paging__loadmore");
      if (pagingLoadmore) {
        if (data.max_page < 2) {
          pagingLoadmore.style.display = "none";
        } else {
          pagingLoadmore.style.display = "block";
        }
      }

      // insert the posts to the container
      const loadmoreContainer = document.querySelector(".loadmore-container");
      if (loadmoreContainer) {
        loadmoreContainer.innerHTML = data.content;
        // Finish filtering
        loadmoreContainer.classList.remove("filtering");
      }
      // Update the number of posts
      const filterCounter = document.querySelector(".filtercounter");
      if (filterCounter) {
        filterCounter.innerHTML = '('+ data.found_posts +')';
      }

      // Scroll to filtering system
      if (document.querySelector(".filter-pin")) {
        document.querySelector(".filter-pin").scrollIntoView({ behavior: "smooth"});
      }

      //Refreshing animations effects
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);

      lazyLoadInstance.update();
    },
    error: function (data) {}
  });
};

const filterForm = document.querySelector('.filter__form');

const filterInit = function () {

  if(!filterForm){
    return;
  }

  filterGetPosts();

  // Adding Event Listeners
  const filterOptions = document.querySelectorAll(".filter__option input");
  filterOptions.forEach(input => {
    if(input.type === 'checkbox'){

      input.addEventListener('change', function () {

        let formData = {};
        
        if(input.type === 'checkbox'){
          // Unchecking all other options
          filterOptions.forEach(el => {
            if (el !== this) {
              el.checked = false;
            }
          });
        }
        filterGetPosts();
      });
    }else if(input.type === 'search'){
      input.addEventListener("keyup", delay(function (e) {
        filterGetPosts();
      }, 500));
    }
  });

  filterForm.addEventListener("submit", function (e) {
    // Stop the form from submitting
    e.preventDefault();
    filterGetPosts();

  });

};

filterInit();

function delay(callback, ms) {
  var timer = 0;
  return function() {
    var context = this, args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      callback.apply(context, args);
    }, ms || 0);
  };
}


/*  ==========================================================================
    Scroll effects
    ========================================================================== */

const effects = document.querySelectorAll(".effect");

const effectsInit = function (effects) {
  if (!effects || effects.length <= 0) {
    return;
  }

  effects.forEach(function (val) {
    const waypoints = new Waypoint({
      element: val,
      handler: function (direction) {
        if (direction === "down") {
          val.classList.add("effect--ready");
        } else {
          val.classList.remove("effect--ready");
        }
      },
      offset: "95%"
    });
  });
}; // effectsInit();
effectsInit(effects);

/*  ==========================================================================
    Homepage Gradient animation (Mobile)
    ========================================================================== */

const homePageheaderBg = document.querySelector('.pageheader--home .pageheader__bgoverlay');

const homepageAnimation = function () {
  if (!homePageheaderBg) {
    return;
  }
  // gsap.set(homePageheaderBg, { top: "100%" });
  gsap.to(homePageheaderBg, {
    scrollTrigger: {
      trigger: ".pageheader--home", // The element to trigger the animation
      start: "top top",           // When the top of the trigger is at the top of the viewport
      end: "bottom",      // End when the bottom of the trigger is at the top of the viewport
      scrub: true              // Makes the animation follow the scroll smoothly
    },
    top: "-20%"  // Target color to change to
  });
};

document.addEventListener("DOMContentLoaded", homepageAnimation);


/*  ==========================================================================
    Marquee - Infinite Scroll
    ========================================================================== */

  const default_animation_speed = 1.5;

  const elClass = "marquee";
  const innerClass = "marquee__wrap";

  const logosMarquees = document.querySelectorAll(".module__marquee");
  
  const marquee__reset = function (el) {
    const wrapElements = el.querySelectorAll("." + innerClass);
  
    const viewportWidth = window.innerWidth;
    const minWidth = (viewportWidth * 1) / 2;
  
    // If the width of the wrap is less than the minimum width we need to duplicate existing tiles
    if (wrapElements[0].offsetWidth < minWidth) {
      // Getting the orginal items
      const originalNumItems = el.dataset.count ? el.dataset.count : 1;
  
      let orginalTiles = "";
  
      const tiles = wrapElements[0].querySelectorAll(".marquee__tile");
  
      for (let index = 0; index < originalNumItems; index++) {
        orginalTiles += '<div class="marquee__tile">' + tiles[index].innerHTML + "</div>";
      }
  
      //Calculating how many times do we need to repeat the original tiles based of the width of the tile
      const numTiles = tiles.length;
      const textWidth = tiles[0].offsetWidth * numTiles;
      const timesToRepeat = Math.ceil((minWidth - wrapElements[0].offsetWidth) / textWidth);
  
      //Adding the extra tiles to the three wraps
      for (let index = 0; index < timesToRepeat; index++) {
        wrapElements[0].innerHTML += orginalTiles;
        wrapElements[1].innerHTML += orginalTiles;
        wrapElements[2].innerHTML += orginalTiles;
      }
    }
  };
  
  const marquee__resize = function (el) {
    // Check if the marquee is large enought for the space
    marquee__reset(el);
  
    // Check if element has custom speed or default
    let animation_speed = default_animation_speed;
    if (el.dataset.speed) {
      animation_speed = el.dataset.speed;
    } else {
      animation_speed = default_animation_speed;
    }
  
    const wrapElements = el.querySelectorAll("." + innerClass);
  
    // Calculate the animation time and delay for each wrap
    let linelength = wrapElements[0].offsetWidth;
    let distance = linelength;
    let speed = animation_speed * 0.01;
    let duration = distance / speed;
  
    let delay = 0 - duration / 3;
  
    wrapElements.forEach(function (wrap, index) {
      let count = index + 1;
      wrap.style.animationDuration = duration + "ms";
      wrap.style.animationDelay = delay * count + "ms";
    });
  };
  
  const logosMarqueeinit = function () {
    if (logosMarquees.length <= 0) {
      return;
    }

    logosMarquees.forEach(elem => {
  
      window.addEventListener("resize", function () {
        marquee__resize(elem);
      });
  
      // Repeating Logos and Text to make sure it fills the width of the view port
      const viewportWidth = window.innerWidth;
      const minWidth = (viewportWidth * 1) / 2;
    
      const tiles = elem.querySelectorAll(".marquee__tile");
      const numTiles = tiles.length;
      const textWidth = tiles[0].offsetWidth * numTiles;
    
      // Wrapping the tiles
      elem.innerHTML = "<div class='" + innerClass + "'>" + elem.innerHTML + "</div>";
    
      // Duplicating the wrap element
      const repeatingTextClone = elem.querySelector(".marquee__wrap").cloneNode(true),
        repeatingTextClone2 = elem.querySelector(".marquee__wrap").cloneNode(true);
    
      repeatingTextClone.ariaHidden = "true";
      repeatingTextClone2.ariaHidden = "true";
    
      elem.appendChild(repeatingTextClone);
      elem.appendChild(repeatingTextClone2);
  
      // Force all lazy images within carousels to load immediately, otherwise they wont load
      // const marquee_lazyimgs = document.querySelectorAll(".marquee .lazy");
      // marquee_lazyimgs.forEach(img => {
      //   LazyLoad.load(img);
      //   console.log(img);
      // });
    
      // Setup animation times
      marquee__resize(elem);
    
      // Once everything is set up, add "loaded" class
      elem.classList.add(elClass + "--loaded");
    });
  };
  
  // Defer loading this code until after page load
  window.addEventListener("load", logosMarqueeinit);
  


/*  ==========================================================================
    ANIMATION - Pinned Content
    ========================================================================== */

const pinnedContentModules = document.querySelectorAll(".module--pinned-content");

const pinnedModuleInit = function (pinnedContentModules) {

  if (!pinnedContentModules || pinnedContentModules.length <= 0) {
    return;
  }

  pinnedContentModules.forEach(function (pinnedContent) {
    const stickyCol = pinnedContent.querySelector(".col--sticky");
    const mediaColumnPinTop = pinnedContent.querySelector(".mediacolumpintop");
    const mediaColumnPinBottom = pinnedContent.querySelector(".mediacolumpinbottom");
    const textColumnPin = pinnedContent.querySelector(".textcolumpin");
    const blockCta = pinnedContent.querySelector(".blockcta__wrap");
    const pinnedMedia = pinnedContent.querySelector(".pinned-content__media"); // Single element
    const pinnedTextItems = pinnedContent.querySelectorAll(".pinned-content__item");

    if (!pinnedMedia || pinnedTextItems.length === 0) {
      return;
    }

    if(blockCta){
      let topInView = false;
      let bottomInView = false;
      const mediaColumnObserverTop = new IntersectionObserver((entries, observer) => {
        // Only interested in the firts entry 
        if (entries[0].isIntersecting) {
        topInView = true;
        }else{
          topInView = false;
        }
      }, {threshold: 1});

      mediaColumnObserverTop.observe(mediaColumnPinTop);

          //Observer for the text colum
      const mediaColumnObserverBottom = new IntersectionObserver((entries, observer) => {

        if (entries[0].isIntersecting) {
        bottomInView = true;
        }else{
          bottomInView = false;
        }

        // Only interested in the firts entry 
        
        if (entries[0].isIntersecting && topInView) {
          blockCta.classList.add('fixed');
        }else if(entries[0].isIntersecting){
          blockCta.classList.remove('fixed');
        }else{
          blockCta.classList.remove('fixed');
        }
          

      }, {threshold: 1});

      mediaColumnObserverBottom.observe(mediaColumnPinBottom);
    

      //Observer for the text colum
      const textColumnObserver = new IntersectionObserver((entries, observer) => {
  
        // Only interested in the firts entry 
        if (entries[0].isIntersecting) {
          blockCta.classList.remove('fixed');
          blockCta.classList.add('fixedbottom');
        }else{
          // is not intersecting
          if(bottomInView){
            blockCta.classList.add('fixed');
            blockCta.classList.remove('fixedbottom');
          }
        }
      }, {threshold: 1});

      textColumnObserver.observe(textColumnPin);

    }
    

    const options = {
      threshold: 0.5,
    };

    const pinnedItemsObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {

          // Remove all active classes
          let mediaItems = pinnedContent.querySelectorAll(".media__item");
          for (let i = 0; i < mediaItems.length; i++) {
            mediaItems[i].classList.remove("active");
          }

          let mediaClass = entry.target.dataset.media;
          if(mediaClass){
            let targetImage = pinnedContent.querySelector("." + mediaClass);
            if (targetImage) {
              targetImage.classList.add("active");
            }
          }
        }
      });
    }, options);

    pinnedTextItems.forEach(item => {
      pinnedItemsObserver.observe(item);
    });

  });
    
};


pinnedModuleInit(pinnedContentModules);


/*  ==========================================================================
    Pageheader Lottie JSON
    ========================================================================== */

const lottieJsons = document.querySelectorAll(
  ".pinned-content__media .media__json"
);

const lottieJsonInit = function (lottieJsons) {
  if (!lottieJsons || lottieJsons.length <= 0) {
    return;
  }
  lottieJsons.forEach(function (lottieJson) {
    const LOTTIE_PATH = lottieJson.dataset.json ? lottieJson.dataset.json : false;

    lottie.loadAnimation({
      container: lottieJson,
      path: LOTTIE_PATH,
      autoplay: true,
      loop: true,
      renderer: "svg",
      rendererSettings: {
        viewBoxOnly: true
      }
    });
  });
};

document.addEventListener("DOMContentLoaded", function(){
  lottieJsonInit(lottieJsons);
});
    

/*  ==========================================================================
   ANIMATION - SVG icon animation
    ========================================================================== */

const svgIcons = document.querySelectorAll(
  ".icon--hover svg, .icon--animation svg"
);

const svgIconsInit = function (svgIcons) {
  if (!svgIcons || svgIcons.length <= 0) {
    return;
  }

  svgIcons.forEach(function (svg) {
    let paths = svg.querySelectorAll('path, circle');
    if(paths.length > 0){
      paths.forEach(function (path) {
        let randomDelay = Math.floor(Math.random() * 650) + 'ms';
        path.style.transitionDelay = randomDelay;
      });
    }
  });
};

svgIconsInit(svgIcons);
/*  ==========================================================================
			Grid Carousel (Currently used on Featured Posts & Featured People)
			========================================================================== */

const gridCarousels = document.querySelectorAll(".row--carousel .owl-carousel");

const gridCarouselInit = function (gridCarousels) {
  if (gridCarousels.length <= 0) {
    return;
  }

  gridCarousels.forEach(elem => {
   
    const slides = elem.querySelectorAll(".col");
    if (!slides) {
      return;
    }

    const responsiveArray = carouselResponsiveArray(elem);

    // Optional data attribute settings
    const autoplay = elem.dataset.autoplay ? elem.dataset.autoplay : false;
    const autoplayTimeout = elem.dataset.autoplayTimeout ? elem.dataset.autoplayTimeout : 5000;
    const loop = elem.dataset.loop ? elem.dataset.loop : false;
    const nav = elem.dataset.nav ? elem.dataset.nav : false;
    const dots = elem.dataset.dots ? elem.dataset.dots : false;
    // Default for autoheight is "true", so to turn off you need to set the data-attribute to "disable"
    const autoHeight = elem.dataset.autoHeight && elem.dataset.autoHeight === "disable" ? false : true;
    const animation = elem.dataset.animation ? true : false;

    const equalHeights = elem.dataset.equalheights ? true : false;

    var owlCarousel = $(elem).owlCarousel({
      autoplay: autoplay,
      autoplayTimeout: autoplayTimeout,
      loop: loop,
      nav: nav,
      animateIn: animation ? 'fadeIn' : false,
      dots: dots,
      items: 1,
      navText: ["<i class='icon icon--arrow-left'></i>", "<i class='icon icon--arrow-right'></i>"],
      responsive: responsiveArray,
      // startPosition: 0,
      autoHeight: autoHeight,
      onInitialized: function () {
        if(equalHeights){
          equalizeHeights(elem);
        }
        lazyLoadInstance.update();
        Waypoint.refreshAll();

        // Setting up index for featureposts
        let parent = elem.closest('.featuredposts');
        if(parent && parent.querySelector('.featuredposts__index')){
          parent.querySelector('.featuredposts__index .current').innerHTML = '1';
        }
        
      },
      onTranslate: function(event){
        // Setting up index for featureposts
        let parent = elem.closest('.featuredposts');
        if(parent && parent.querySelector('.featuredposts__index')){
          let currentIndex = event.item.index + 1; 
          parent.querySelector('.featuredposts__index .current').innerHTML = currentIndex;
        }
      },
      onResized: function(event){
        if(equalHeights){
          equalizeHeights(elem);
        }
      },
      onRefreshed:  function(event){
        if(equalHeights){
          equalizeHeights(elem);
        }
      }
    });

    // Safari iOS fix, causing a 1px height until a carousel change happened
    var adjustCarouselHeight = setInterval(function () {
      if (owlCarousel.height() > 1) {
        clearInterval(adjustCarouselHeight);
      }
      owlCarousel.trigger("refresh.owl.carousel", [100]);
    }, 300);


    $(elem).on("resized.owl.carousel", function (event) {
      // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });

     // Optionally re-run on window resize just to be safe
      window.addEventListener('resize', () => {
        equalizeHeights();
      });

   
  });
}; // gridCarouselInit();
gridCarouselInit(gridCarousels);

/*  ==========================================================================
    Grid Carousel - Equal height columns function
    ========================================================================== */

function equalizeHeights(elem) {
  let maxHeight = 0;

  if(!elem || elem.length <= 0){
    return;
  }

  const items = elem.querySelectorAll(".col");
  // Reset heights
  items.forEach(item => {
    item.style.height = 'auto';
  });
  // Find max height
  items.forEach(item => {
    const itemHeight = item.offsetHeight;
    if (itemHeight > maxHeight){ 
      maxHeight = itemHeight;
    }
  });

  // Set all to max height
  items.forEach(item => {
    item.style.height = `${maxHeight}px`;
  });
}

/*  ==========================================================================
    Grid Carousel - Create responsive array 
    ========================================================================== */

function carouselResponsiveArray(elem) {
  let responsiveArray = {};
  const slides = elem.querySelectorAll(".col");
  const classes = slides[0].classList;

  classes.forEach((cl, index) => {
    if (cl.indexOf("col-") !== -1) {
      let className = cl;
      let classWidth = 0;
      let numItems = 4;
      className = cl.replace("col-", "");
      // get min width from col class
      const classGridsize = className.split("-")[0];
      // check this is a string not a number, this will remove up cols that dont have a grid size e.g. col-1-2
      if (isNaN(classGridsize)) {
        className = className.replace(classGridsize + "-", "");
        classWidth = gridSizes[classGridsize];
      } else {
        classWidth = 0;
      }
      // split rest of class into sections (this should now be something like '1-4')
      const otherClassParts = className.split("-");
      // divide second number (e.g 4) by first number (e.g 1) to get number of items
      if (otherClassParts[1]) {
        numItems = otherClassParts[1] / otherClassParts[0];
      } else {
        numItems = 1; // if there isn't a second number it must be a single grid
      }
      responsiveArray[classWidth] = {
        items: numItems
      };
    }
  });

  return responsiveArray;
} // carouselResponsiveArray();

/*  ==========================================================================
    Image Edge Carousel
    ========================================================================== */

const edgeCarousels = document.querySelectorAll(".edge-carousel");

const edgeCarouselInit = function (edgeCarousels) {
  if (edgeCarousels.length <= 0) {
    return;
  }

  edgeCarousels.forEach(elem => {
    const slides = elem.querySelectorAll(".col");
    if (!slides) {
      return;
    }

    var owlCarousel = $(elem).owlCarousel({
      items: 1,
      loop: true,
      nav: false,
      margin: 0,
      autoWidth: true,
      dots: false,
      lazyLoad: true,
      lazyLoadEager: 2,
      onInitialized: function () {
        lazyLoadInstance.update();
        Waypoint.refreshAll();
      },
      onTranslated: function (event) {
      },
      onTranslate: function () {
        // refreshing lazyload to target the clone images
        lazyLoadInstance.update();
      },
    });

    // Safari iOS fix, causing a 1px height until a carousel change happened
    var adjustCarouselHeight = setInterval(function () {
      if (owlCarousel.height() > 1) {
        clearInterval(adjustCarouselHeight);
      }
      owlCarousel.trigger("refresh.owl.carousel", [100]);
    }, 300);

    $(elem).on("resized.owl.carousel", function (event) {
      // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });
  });
}; // edgeCarouselInit();
edgeCarouselInit(edgeCarousels);

/*  ==========================================================================
    Feature Carousel
    ========================================================================== */

const featureCarousels = document.querySelectorAll(".feature-carousel");

const featureCarouselInit = function (featureCarousels) {
  if (featureCarousels.length <= 0) {
    return;
  }

  featureCarousels.forEach(module => {

    const textCarousel = module.querySelector(".items__textitems .owl-carousel");
    const mediaCarousel = module.querySelector(".items__mediaitems .owl-carousel");

    const textSlides = textCarousel.querySelectorAll(".col");
    const mediaSlides = mediaCarousel.querySelectorAll(".col");

    if (!textCarousel || !mediaCarousel || !textSlides || !mediaSlides) {
      return;
    }
    
    const responsiveArray = carouselResponsiveArray(textCarousel);

    let textOwlCarousel = $(textCarousel).owlCarousel({
      items: 1,
      margin: 0,
      responsive: responsiveArray,
      dots: true,
      nav: false,
      animateOut: "fadeOut",
      animateIn: "fadeIn",
      onInitialized: function () {
        lazyLoadInstance.update();
        Waypoint.refreshAll();

        textCarousel.querySelectorAll(".owl-item")[0].classList.add('current');
        startProgressBar(textCarousel.querySelector(".current"));
      },
      onTranslate: function (event) {
        // refreshing lazyload to target the clone images
        lazyLoadInstance.update();
      },
    }).on('changed.owl.carousel', function(event){
      mediaOwlCarousel.data('owl.carousel').to(event.item.index, 300, true);
    });

    let mediaOwlCarousel = $(mediaCarousel).owlCarousel({
      items: 1,
      rewind: true,
      nav: false,
      autoplay: true,
      autoplayTimeout: 8000,
      animateOut: "fadeOut",
      animateIn: "fadeIn",
      slideTransition: "cubic-bezier(.25,.75,.5,.85)",
      margin: 0,
      smartSpeed: 600,
      dots: true,
      onInitialized: function () {
        lazyLoadInstance.update();
        Waypoint.refreshAll();

      },
      onTranslate: function (event) {
        // refreshing lazyload to target the clone images
        lazyLoadInstance.update();
        
      },
    })
    .on('changed.owl.carousel', syncPositions)
    // Reset autoplay when user finishes dragging/swiping
    .on('translated.owl.carousel', function() {
        mediaOwlCarousel.trigger('stop.owl.autoplay'); // stop first
        mediaOwlCarousel.trigger('play.owl.autoplay', [5000]); // restart with timeout
    });

    // Event Listeners
    textOwlCarousel.on("click", ".owl-item", function(e) {
        e.preventDefault();
        var number = $(this).index();
        mediaOwlCarousel.data('owl.carousel').to(number, 300, true);
    });

    
    function syncPositions(event) {
      
      resetProgressBar(textCarousel.querySelector(".current"));
      textCarousel.querySelector(".current").classList.remove('current');
      
      textCarousel.querySelectorAll(".owl-item")[event.item.index].classList.add('current');
  
      textOwlCarousel.data('owl.carousel').to(event.item.index, 100, true);

      startProgressBar(textCarousel.querySelector(".current"));
    }
  
  });
};

const startProgressBar = function (el) {
  // apply keyframe animation
  const itemProgress = el.querySelector(".item__progress");
  if (!itemProgress) {
    return;
  }

  itemProgress.style.width = "100%";
  itemProgress.style.transition = "width " + 5000 + "ms linear";
};

const resetProgressBar = function (el) {
  const itemProgress = el.querySelector(".item__progress");
  if (!itemProgress) {
    return;
  }

  itemProgress.style.width = 0;
  itemProgress.style.transition = "width 0s linear";
};
    
featureCarouselInit(featureCarousels);


/*  ==========================================================================
    Tabbed Content Carousel
    ========================================================================== */

const tabbedCarousels = document.querySelectorAll(".module--tabbed-content");

const tabbedCarouselInit = function (tabbedCarousels) {
  if (tabbedCarousels.length <= 0) {
    return;
  }

  tabbedCarousels.forEach(elem => {

    const elemOwl = elem.querySelector(".owl-carousel");

    const options = elem.querySelectorAll(".tabbed-content__option");
    options.forEach(option => {
      option.addEventListener('click', function(){
        let id = option.dataset.id;
        const options = elem.querySelector('.tabbed-content__option.active').classList.remove('active');
        option.classList.add('active');
        owlCarousel.data('owl.carousel').to(id, 100, true);
      });
    });

    const slides = elemOwl.querySelectorAll(".item");
    if (!slides) {
      return;
    }

    var owlCarousel = $(elemOwl).owlCarousel({
      items: 1,
      loop: false,
      nav: false,
      // animateOut: "fadeOut",
      animateIn: "fadeIn",
      margin: 0,
      dots: false,
      onInitialized: function () {
        lazyLoadInstance.update();
        Waypoint.refreshAll();
      },
      onTranslated: function (event) {
      },
      onTranslate: function () {
        // refreshing lazyload to target the clone images
        lazyLoadInstance.update();
      },
    }).on('changed.owl.carousel', tabbedSyncPositions);

    function tabbedSyncPositions(event) {
      
      let activiElem = elemOwl.querySelectorAll(".owl-item")[event.item.index];

      if(activiElem.querySelector('.item')){
        let activiElemID = activiElem.querySelector('.item').dataset.id;
        activiElemID = activiElemID.replace("item-", "");
        if(activiElemID){
          // Removing active class from the active item
          elem.querySelector('.tabbed-content__option.active').classList.remove('active');
          let nextactive = elem.querySelector('.tabbed-content__option[data-id="'+activiElemID+'"]');
          if(nextactive){
            nextactive.classList.add('active');
          }

        }
      }
    }

  });

};

tabbedCarouselInit(tabbedCarousels);

/*  ==========================================================================
	NAVIGATION - mobnav
	========================================================================== */

const mobnav = document.querySelector(".mobnav");
const siteHeaderBd = document.querySelector(".siteheader__bd");
const mobnavToggle = document.querySelector(".mobnav-toggle");
const mobnavOpenclass = "mobnavopen";

const mobnavSetHeight = function () {
  const mobnavHeight = window.innerHeight - siteHeaderBd.getBoundingClientRect().height;
  mobnav.style.height = `${mobnavHeight}px`;
}; // mobnavSetHeight()

const mobnavInit = function () {
  // Open mobnav on click the toggle
  mobnavToggle.addEventListener("click", function (e) {
    e.preventDefault();
    if (!body.classList.contains(mobnavOpenclass)) {
      // IT'S NOT OPEN...
      body.classList.add(mobnavOpenclass);
    } else {
      // IT'S OPEN...
      body.classList.remove(mobnavOpenclass);
    }
  });
}; // mobnavInit()
mobnavInit();

/*  ==========================================================================
      NAVIGATION - mobnav dropdowns
      ========================================================================== */

const mobnavLinks = document.querySelectorAll(".mobnav .sitenav__item--hasdropdown .sitenav__item__dropdownarrow");

const mobnavlinksInit = function () {
  if (!mobnavLinks) {
    return;
  }

  mobnavLinks.forEach(function (mobnavLink) {
    mobnavLink.addEventListener("click", function (e) {
      e.preventDefault();
      const mobnavTargetSection = e.target.closest(".sitenav__item");
      mobnavTargetSection.classList.toggle("sitenav__item--open");

      var dropdown = this.nextElementSibling;
      if (dropdown.style.maxHeight) {
        dropdown.style.maxHeight = null;
      } else {
        dropdown.style.maxHeight = dropdown.scrollHeight + "px";
      }

    });
  });
}; // mobnavlinksInit();
mobnavlinksInit();

/*  ==========================================================================
	NAVIGATION - Search
	========================================================================== */

// Search open & close
const searchNav = document.querySelector(".siteheader__search");
const searchToggle = document.querySelector(".search-toggle");
const searchInput = document.querySelector(".siteheader__search .searchform__input input");

// Close search modal when clicked elsewhere in the document
const clickedOusideSearch = function (e) {
  if (!searchNav.classList.contains("siteheader__search--open")) {
    return;
  }

  var isClickInsideElement =
    searchNav.contains(e.target) || searchToggle === e.target || searchToggle.contains(e.target);

  if (!isClickInsideElement) {
    searchNav.classList.remove("siteheader__search--open");
    body.removeEventListener("mouseup", clickedOusideSearch, false);
  }
}; // clickedOusideSearch();

// Toggle search modal window
const searchModalToggle = function (e) {
  e.preventDefault();
  if (searchNav.classList.contains("siteheader__search--open")) {
    searchNav.classList.remove("siteheader__search--open");
    body.removeEventListener("mouseup", clickedOusideSearch, false);
  } else {
    searchNav.classList.add("siteheader__search--open");
    searchInput.focus();
    body.addEventListener("mouseup", clickedOusideSearch, false);
  }
}; // searchModalToggle();

const searchModalInit = function () {
  if (!searchNav) {
    return;
  }
  searchToggle.addEventListener("click", searchModalToggle);
}; // searchModalInit();

searchModalInit();

/*  ==========================================================================
    NAVIGATION - Product Dropdown
    ========================================================================== */

    // const siteheader = document.querySelector(".siteheader");
    const sitenav = document.querySelector(".sitenav--center");
    const sitenavitems = sitenav.querySelectorAll(".sitenav__item--products");
    const sitenavdropdown = document.querySelector(".productnav");
    const sitenavdropdownsections = document.querySelectorAll(".productnavsection");
    
    const overclass = "sitenav__item--over";
    const navopenbodyclass = "productnavopen";
    const activesectionclass = "productnavsection--active";
    
    var navopen = false;
    var currentli = false;
    var dropdownclosetimer = false;
    let currentTopLevelItem = false;
    let nextTabItem = false;
    
    // Check if isMobile, and only init if desktop or Ipad
    if (!isMobile) {
      productnav__init();
    }
    
    function productnav__init() {

      if (!sitenavdropdown) {
        return;
      }
      
      // Check if is touchscreen and setup dropdown to show on tap as well as hover
      if (isTouchDevice) {
        // IF TOUCHSCREEN (e.g. Ipad users)...
        // Setup dropdown to show on tap
        sitenavitems.forEach(function (sitenavitem) {
          sitenavitem.addEventListener("click", function (e) {
            e.preventDefault();
    
            if (!this.classList.contains(overclass)) {
              navopen = false;
              sitenavitem__over(sitenavitem);
            } else {
              sitenav__out();
            }
          });
        });
      } else {
        // IF DESKTOP...
        sitenavitems.forEach((sitenavitem, index) => {
          sitenavitem.addEventListener("mouseover", e => {
            sitenavitem__over(sitenavitem);
          });
          sitenavitem.addEventListener("mouseout", e => {
            sitenav__out();
          });
          // Listening for focus on the sitenav item to open the dropdown
          sitenavitem.addEventListener("focusin", e => {
            currentTopLevelItem = sitenavitem;
            sitenavitem__over(sitenavitem);
          });
    
          // Listing for keydown on the sitenavitem to take the user into the the dropdown
          sitenavitem.addEventListener("keydown", function (event) {
            let dropdownsection = sitenavdropdown.querySelector(".productnavsection--" + sitenavitem.dataset.index);
    
            let sectionLinks = dropdownsection.getElementsByTagName("a");
            let firstSectionLink = sectionLinks[0];
    
          });
        });

        sitenavdropdown.addEventListener("mouseover", e => {
          dropdownsection__over();
        });
        sitenavdropdown.addEventListener("mouseout", e => {
          sitenav__out();
        });
    
        // sitenavdropdown.addEventListener("keydown", function (event) {
        //   // Escaping the dropdown on tab navigation
        //   if (
        //     event.key === "Escape" &&
        //     (sitenavdropdown.contains(document.activeElement) || currentTopLevelItem.contains(document.activeElement))
        //   ) {
        //     sitenav__out();
        //   }
        // });
      }
    } // sitenav__init()
    
    function sitenavitem__over(sitenavitem) {
      // On hover of sitenav item
      dropdownsection__open(sitenavitem);
    } // sitenavitem__over()
    
    function dropdownsection__open(target_li) {
      var target_section = sitenavdropdown.querySelector(".productnavsection--" + target_li.dataset.index);
      var dropdown_height = target_section.offsetHeight;
    
      let sectionLinks = target_section.querySelectorAll("a");
      let firstSectionLink = sectionLinks[0];
      let firstTimein = true;
    
      // Make dropdown show and set classes to say it's open
      sitenavdropdown.style.visibility = "visible";
      sitenavdropdown.style.height = dropdown_height + "px";
      navopen = true;
      if (dropdownclosetimer) {
        // Clear timeout to stop dropdown closing
        window.clearTimeout(dropdownclosetimer);
      }
      // Remove over class from any old clicks
      if (document.querySelector("." + overclass)) {
        document.querySelector("." + overclass).classList.remove(overclass);
      }
      // add over class to current li
      target_li.classList.add(overclass);
      document.querySelector("body").classList.add(navopenbodyclass);
      if (document.querySelector("." + activesectionclass)) {
        document.querySelector("." + activesectionclass).classList.remove(activesectionclass);
      }
      target_section.classList.add(activesectionclass);
    } //dropdownsection__open();
    
    function dropdownsection__over() {
      // On hover of dropdownsection, keep the dropdown open
      navopen = true;
      if (dropdownclosetimer) {
        // Clear timeout to close the dropdown
        window.clearTimeout(dropdownclosetimer);
      }
      document.querySelector("body").classList.add(navopenbodyclass);
    } // sitenavitem__over()
    
    function sitenav__out() {
      // On leave sitenav hover
      navopen = false;
      //Setting responsive attribute to false
      sitenavitems.forEach(function (sitenavitem) {
        let sitenavlink = sitenavitem.querySelector(".sitenav__link");
      });
      // Start timeout to close sitenav dropdown
      dropdownclosetimer = window.setTimeout(sitenav__close, 250);
    } // sitenavitem__over()
    
    function sitenav__close() {
      // when time out ends and nav open is still false, close the sitenav
      if (!navopen) {
        // Set height to 0 and remove classes
        if (document.querySelector("." + activesectionclass)) {
          document.querySelector("." + activesectionclass).classList.remove(activesectionclass);
        }
        document.querySelector("body").classList.remove(navopenbodyclass);
        if (document.querySelector("." + overclass)) {
          document.querySelector("." + overclass).classList.remove(overclass);
        }
        sitenavdropdown.style.height = 0;
        sitenavdropdown.style.visibility = "hidden";
      }
    } // sitenav__close


  /*  ==========================================================================
	NAVIGATION - Dropdown moving dots
	========================================================================== */

const dropdownLists = document.querySelectorAll(".sitenav__item__dropdown .dropdown__list");
    
const dropdownListsInit = function () {

  if (dropdownLists.length <= 0) {
    return;
  }

  dropdownLists.forEach(list => {

    const links = list.querySelectorAll('.dropdown__link');
    const dot = list.querySelector('.dot');

    links.forEach(item => {
      item.addEventListener('mouseenter', () => {
        dot.style.top = item.offsetTop + item.offsetHeight/2 - dot.offsetHeight/2 + 'px'; /* Example: move to the left of the hovered item */
        dot.style.opacity = 1;
      });
      item.addEventListener('mouseleave', () => {
        dot.style.opacity = 0;
      });
    });
  });

}; // mobnavInit()
dropdownListsInit();

/*  ==========================================================================
	FORM - Trigger after Form Submission
	========================================================================== */

const triggerAfterSubmit = function () {
  jQuery(document).on("gform_confirmation_loaded", function (event, formId) {
    Waypoint.refreshAll();
  });
};

triggerAfterSubmit();
